



















































































































































































































































































import "animate.css";
import * as echarts from "echarts";
import { Component, Vue, Watch, Inject } from "vue-property-decorator";
import { getIndexCjType } from "../api/index";
import {
  getPrice,
  getLevel,
  getBrand,
  getZbcj,
  getVoteCount,
  getVote,
} from "../api/cjCarType";
import { getUserInfo } from "../api/common";
import wxshare from "../components/share.vue";
import downLoadApp from "../components/downloadApp.vue";

import JQuery from "jquery";
import wx from "weixin-js-sdk";
Component.registerHooks(["beforeRouteEnter"]);
@Component({
  components: {
    wxshare,
    downLoadApp,
  },
})
export default class cjCarType extends Vue {
  @Inject("getUserToken") private getUserToken: any;
  $toast: any;
  $route: any;
  $store: any;
  $router: any;
  chartDom: any;
  myChart: any;
  currentRate: any = 0;
  downloadTF: boolean = false;
  pirceIndex: any = 0;
  indexList: any[] = [];
  levelData: any[] = [];
  priceData: any[] = [];
  levelIndex: any = 0;
  yearIndex: any = 0;
  brandData: any[] = [];
  value1: any = 0;
  value2: any = 0;
  value3: any = 0;
  value4: any = 0;
  value5: any = 0;
  value6: any = 0;
  cjValue: any = 0;
  ycjData: any = {};
  ycjListData: any[] = [];
  menuTitle: any = "";
  //title选项
  option1: any = [
    { text: "已拆解车型", value: 0 },
    { text: "拆解中车型", value: 1 },
    { text: "准备拆解车型", value: 2 },
  ];
  //dropdown最新选项
  cjOption: any = [
    { text: "全部拆解", value: 1 },
    { text: "部分拆解", value: 2 },
  ];
  //dropdown评分选项
  option3: any = [
    { text: "默认", value: 0 },
    { text: "按评分降序", value: 1 },
    { text: "按评分升序", value: 2 },
  ];
  //dropdown年款选项
  yearData: any = [
    { text: "不限", value: "" },
    { text: "2021年", value: 2021 },
    { text: "2020年", value: 2020 },
    { text: "2019年", value: 2019 },
    { text: "2018年", value: 2018 },
    { text: "2017年", value: 2017 },
    { text: "2016年", value: 2016 },
    { text: "2015年", value: 2015 },
  ];
  //准备拆解数据
  zbcjValue: any = "";
  zbcjValue1: any = "";
  zbcjValue2: any = "";
  zbcjValue3: any = "";
  zbcjPirceIndex: any = 0;
  zbCjlevelIndex: any = 0;
  zbcjTypeData: any[] = [];
  zbcjOption: any = [
    { text: "全部", value: 1 },
    { text: "按投票想拆降序", value: 5 },
    { text: "按上市时间降序", value: 6 },
  ];
  zbcjLevelData: any[] = [];
  zbcjLoading: any = false;
  zbcjFinished: any = false;
  loading: any = false;
  finished: any = false;
  titleIndex: any = 0;
  //已拆解请求参数
  cjParams: any = {
    voteType: 0, //0 取全部 1 全部拆解 2 部分拆解
    pageNo: 1,
    pageSize: 10,
    sortType: 0, //0 默认 1 评分降序 2评分升序
    brandId: "", //品牌id
    disStatus: 4, //3拆解中，4已拆解
    minPrice: "",
    maxPrice: "",
    level: "", //级别
    year: "", //年款
  };
  //准备拆解请求参数
  zbcjParams: any = {
    voteType: 2,
    pageNo: 1,
    pageSize: 10,
    sortType: 1, //‘’ 全部  5 想拆降序 6 上市时间降序
    brandId: "", //品牌id
    minPrice: "",
    maxPrice: "",
    level: "", //级别
  };
  zbcjOptArr: any[] = [];
  cjOptArr: any[] = [];
  zbcjCount: any = 0;
  timeStamp: any = new Date().getTime();
  shareTipTF: any = false;
  userAgent: any;
  wxShareUrl: any;
  token: any = "";
  phone: any = "";
  mounted() {
    this.userAgent = navigator.userAgent.toLowerCase();
    this.token = window.localStorage.getItem("userToken");

    //获取已拆解数据
    // this.getCjScoreData();
    //获取价格数据
    this.getPriceData();
    //获取级别数据
    this.getLevelData();
    //获取品牌数据
    this.getBrandData();
    this.$nextTick(() => {
      if (this.$route.query.index == 2) {
        this.value1 = 2;
        this.changeDevelop(2);
      }
    });
  }
  changeDownload(val: any) {
    this.downloadTF = val;
  }
  changeShare(val: any) {
    this.shareTipTF = val;
  }
  goSeriesPage(item: any) {
    window.location.href =
      "http://m.chexun.com/app/appseries#/?seriesId=" + item.seriesId;
  }
  voteClick(item: any, index: any) {
    this.token = window.localStorage.getItem("userToken");
    if (!this.token) {
      this.getUserToken();
    } else {
      let params: any = {
        voteId: item.voteId,
        token: this.token,
      };
      getVoteCount(params).then((res: any) => {
        if (res.msg >= 1) {
          this.getUserInfoData(item, index);
        } else {
          this.$toast.text("一个车型只能投三次票哦");
        }
      });
    }
  }
  getUserInfoData(item: any, index: any) {
    let params = {
      token: this.token,
    };
    getUserInfo(params).then((res: any) => {
      this.phone = res.data.phone;
      this.getVoteData(item, index);
    });
  }
  getVoteData(item: any, index: any) {
    let params: any = {
      voteId: item.voteId,
      token: this.token,
      phone: this.phone,
      type: 0,
    };
    getVote(params).then((res: any) => {
      this.zbcjTypeData[index].dissNum += 1;
      this.$toast.text(res.data.msg);
    });
  }
  shareUrl(item: any) {
    this.wxShareUrl = window.location.origin + "/download";
    if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
      this.shareTipTF = true;
      this.wxShareData(item);
    } else {
      this.downloadTF = true;
    }
  }
  // 微信分享
  wxShareData(typeData: any) {
    var that = this;
    JQuery.ajax({
      type: "get",
      url: "http://reg.chexun.com/api/WeiXinInfo.ashx",
      cache: false,
      dataType: "jsonp",
      data: { url: that.wxShareUrl },
      jsonpCallback: "funcweixin",
      success: function (data: any) {
        wx.config({
          debug: false, // true开启调试模式,pc端会console.log手机端会alert
          appId: data.appId, // 必填，公众号的唯一标识，填自己的！
          timestamp: data.wxinfo.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
          nonceStr: data.wxinfo.nonceStr, // 必填，生成签名的随机串
          signature: data.wxinfo.signature, // 必填，签名，见附录1
          jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
        });
        wx.ready(function () {
          //分享到朋友圈
          wx.updateTimelineShareData({
            title: typeData.reportName, // 分享时的标题
            link: that.wxShareUrl, // 分享时的链接
            imgUrl: typeData.clubCover, // 分享时的图标
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              // alert("取消分享");
            },
          });
          //分享给朋友
          wx.updateAppMessageShareData({
            title: typeData.reportName,
            desc: typeData.clubDesc,
            link: that.wxShareUrl,
            imgUrl: typeData.clubCover,
            success: function () {
              console.log("分享成功");
              //alert("分享成功");
            },
            cancel: function () {
              //alert("取消分享");
            },
          });
        });
      },
      error: function () {
        alert("error");
      },
    });
  }
  //跳转拆解详情页
  goCjDetail(params: any) {
    this.$router.push({
      path: "/cjDetail",
      query: {
        reportId: params.reportId,
      },
    });
  }
  //跳转到首页
  goIndex() {
    this.$router.push({
      path: "/",
    });
  }
  //返回上一页
  goBack() {
    this.$router.go(-1);
  }

  //判断路由来源
  beforeRouteEnter(to: any, from: any, next: any) {
    if (from.path == "/cjDetail" || from.path == "/login") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  }
  activated() {
    if (!this.$route.meta.isBack) {
      this.value1 = 0;
      this.initCjscoreData();
    }
    this.$route.meta.isBack = true;
  }
  //改变头部
  changeDevelop(index: any) {
    // 重置参数
    this.cjParams = {
      voteType: 0, //0 取全部 1 全部拆解 2 部分拆解
      pageNo: 1,
      pageSize: 10,
      sortType: 0, //0 默认 1 评分降序 2评分升序
      brandId: "", //品牌id
      disStatus: 4, //3拆解中，4已拆解
      minPrice: "",
      maxPrice: "",
      level: "", //级别
      year: "", //年款
    };
    this.zbcjParams = {
      voteType: 2,
      pageNo: 1,
      pageSize: 10,
      sortType: 1, //‘’ 全部  5 想拆降序 6 上市时间降序
      brandId: "", //品牌id
      minPrice: "",
      maxPrice: "",
      level: "", //级别
    };
    this.titleIndex = index;
    this.menuTitle = this.option1[this.titleIndex].text;
    if (index == 2) {
      this.initZbCjscoreData();
    } else {
      if (index == 0) {
        this.cjParams.disStatus = 4;
      } else {
        this.cjParams.disStatus = 3;
      }
      this.initCjscoreData();
    }
  }

  //重置数据
  initCjscoreData() {
    this.ycjListData = [];
    this.finished = false;
    this.cjParams.pageNo = 1;
    this.getCjScoreData();
  }
  //已拆解数据无限滚动
  onLoad() {
    setTimeout(() => {
      if (this.ycjListData.length >= this.ycjData.count) {
        this.finished = true;
      } else {
        this.cjParams.pageNo += 1;
        this.getCjScoreData();
      }
    }, 300);
  }
  // 获取已拆解数据
  getCjScoreData() {
    let params = this.cjParams;
    getIndexCjType(params).then((res: any) => {
      this.ycjData = res.data;
      this.loading = false;
      if (res.data.list.length < 10) {
        this.finished = true;
      }
      let currentTime: any = new Date();
      let totalTime: any;
      this.ycjListData = this.ycjListData.concat(res.data.list);
      for (let y in this.ycjListData) {
        this.ycjListData[y].years = this.ycjListData[y].finishTime.split("-");
        this.ycjListData[y].carProgress =
          (this.ycjListData[y].currentFinishTime - currentTime.getTime()) /
          (1000 * 3600 * 24);
        totalTime =
          (this.ycjListData[y].currentFinishTime -
            this.ycjListData[y].currentCreateTime) /
          (1000 * 3600 * 24);
        totalTime = parseInt(totalTime);
        this.ycjListData[y].carProgress = parseInt(
          this.ycjListData[y].carProgress
        );
        this.ycjListData[y].carProgress =
          totalTime - this.ycjListData[y].carProgress;
        this.ycjListData[y].carProgress =
          (this.ycjListData[y].carProgress / totalTime) * 100;
        this.ycjListData[y].carProgress = parseInt(
          this.ycjListData[y].carProgress
        );
        if (this.ycjListData[y].carProgress == 100) {
          this.ycjListData[y].carProgress = 95;
        }
      }
      this.menuTitle = this.option1[this.titleIndex].text + this.ycjData.count;
      this.$nextTick(() => {
        for (let i in this.ycjListData) {
          if (this.ycjListData[i].flowStatus == 4) {
            this.ycjListData[i].totalScore = [];
            for (let y in this.ycjListData[i].firstScore) {
              this.ycjListData[i].totalScore.push(
                this.ycjListData[i].firstScore[y].firstScore
              );
            }
            this.chartDom = document.getElementById(
              `cjMain${i}`
            ) as HTMLElement;
            this.myChart = echarts.init(this.chartDom);
            this.myChart.setOption(this.initCjMain(this.ycjListData[i]));
          }
        }
      });
    });
  }
  //重置准备拆解数据
  initZbCjscoreData() {
    this.zbcjTypeData = [];
    this.zbcjParams.pageNo = 1;
    this.getZbcjData();
  }
  //准备拆解数据无限滚动
  zbcjOnLoad() {
    setTimeout(() => {
      if (this.zbcjTypeData.length >= this.zbcjCount) {
        this.zbcjFinished = true;
      } else {
        this.zbcjParams.pageNo += 1;
        this.getZbcjData();
      }
    }, 300);
  }
  //获取准备拆解数据
  getZbcjData() {
    this.zbcjFinished = false;
    let params = this.zbcjParams;
    getZbcj(params).then((res: any) => {
      this.zbcjLevelData = res.data.levels;
      this.zbcjLevelData.unshift({
        id: "",
        name: "不限",
        sort: "",
      });
      this.zbcjCount = res.data.count;
      this.zbcjTypeData = this.zbcjTypeData.concat(res.data.list);
      this.zbcjLoading = false;
      if (res.data.list.length < 10) {
        this.zbcjFinished = true;
      }
      this.menuTitle = this.option1[this.titleIndex].text + res.data.count;
    });
  }
  //改变准备拆解价格index
  changeZbcjPriceIndex(index: any, item: any) {
    this.zbcjPirceIndex = index;
    this.zbcjParams.minPrice = item.minPrice;
    this.zbcjParams.maxPrice = item.maxPrice;
    this.initZbCjscoreData();
    let data = {
      text: item.levelValue,
      name: "zbPrice",
    };
    this.addzbOptionArr(data);
    (this.$refs.zbcjItem as any).toggle();
  }
  //添加准备拆解选项
  addzbOptionArr(params: any) {
    if (this.zbcjOptArr.length == 0) {
      this.zbcjOptArr.push(params);
    } else {
      var result = this.zbcjOptArr.some((item) => {
        if (item.name === params.name) {
          item.text = params.text;
          return true;
        }
      });
      if (!result) {
        this.zbcjOptArr.push(params);
      }
    }
  }
  //添加已拆解选项
  addOptionArr(params: any) {
    if (this.cjOptArr.length == 0) {
      this.cjOptArr.push(params);
    } else {
      var result = this.cjOptArr.some((item) => {
        if (item.name === params.name) {
          item.text = params.text;
          return true;
        }
      });
      if (!result) {
        this.cjOptArr.push(params);
      }
    }
  }
  //改变准备拆解级别Index
  changeZbCjLevelIndex(index: any, item: any) {
    this.zbCjlevelIndex = index;
    this.zbcjParams.level = item.id;
    let data = {
      text: item.name,
      name: "zbjb",
    };
    this.initZbCjscoreData();
    this.addzbOptionArr(data);
    (this.$refs.zbcjItem1 as any).toggle();
  }
  //改变准备拆解最新index
  changeZbzx(index: any) {
    let data: any = {
      text: "",
      name: "zbzx",
    };
    switch (index) {
      case 1:
        data.text = "全部";
        break;
      case 5:
        data.text = "投票想拆降序";
        break;
      case 6:
        data.text = "上市时间降序";
        break;
    }
    this.zbcjParams.sortType = index;
    this.initZbCjscoreData();
    this.addzbOptionArr(data);
  }
  //改变准备拆解品牌index
  changeZbcjBrandIndex(item: any) {
    let data = {
      text: item.brandName,
      name: "zbpp",
    };
    this.zbcjParams.brandId = item.brandId;
    this.initZbCjscoreData();
    this.addzbOptionArr(data);
    (this.$refs.zbcjItem2 as any).toggle();
  }

  //改变年款index
  changeYearIndex(index: any, item: any) {
    this.yearIndex = index;
    this.cjParams.year = item.value;
    let data = {
      text: item.value,
      name: "cjnk",
    };
    this.addOptionArr(data);
    this.initCjscoreData();
    (this.$refs.item3 as any).toggle();
  }

  //改变价格index
  changePriceIndex(index: any, item: any) {
    this.pirceIndex = index;
    this.cjParams.minPrice = item.minPrice;
    this.cjParams.maxPrice = item.maxPrice;
    let data = {
      text: item.levelValue,
      name: "cjjg",
    };
    this.addOptionArr(data);
    this.initCjscoreData();
    (this.$refs.item as any).toggle();
  }

  //改变级别Index
  changeLevelIndex(index: any, item: any) {
    this.levelIndex = index;
    this.cjParams.level = item.levelId;
    let data = {
      text: item.levelValue,
      name: "cjjb",
    };
    this.addOptionArr(data);
    this.initCjscoreData();
    (this.$refs.item1 as any).toggle();
  }

  //改变最新index
  changeZx(index: any) {
    this.cjParams.voteType = index;
    let data = {
      text: "",
      name: "cjzx",
    };
    switch (index) {
      case 0:
        data.text = "全部拆解";
        break;
      case 1:
        data.text = "部分拆解";
        break;
    }
    this.addOptionArr(data);
    this.initCjscoreData();
  }
  //改变评分index
  changePf(index: any) {
    this.cjParams.sortType = index;
    let data = {
      text: "",
      name: "cjpf",
    };
    switch (index) {
      case 0:
        data.text = "默认";
        break;
      case 1:
        data.text = "评分降序";
        break;
      case 2:
        data.text = "评分升序";
        break;
    }
    this.addOptionArr(data);
    this.initCjscoreData();
  }

  //改变品牌index
  changeBrandIndex(item: any) {
    this.cjParams.brandId = item.brandId;
    let data = {
      text: item.brandName,
      name: "cjpp",
    };
    this.addOptionArr(data);
    this.initCjscoreData();
    (this.$refs.item2 as any).toggle();
  }
  initCjMain(params: any) {
    return {
      title: [
        {
          text: params.score,
          left: "38%",
          top: "center",
          textStyle: {
            fontSize: 14,
            color: "rgba(18, 24, 38, 1)",
          },
        },
        {
          text: "分",
          left: "49%",
          top: "center",
          textStyle: {
            fontSize: 10,
            color: "rgba(18, 24, 38, 1)",
          },
        },
      ],
      radar: [
        {
          indicator: [
            {
              name: params.firstScore[0].firstName,
              max: 100,
            },
            {
              name: params.firstScore[1].firstName,
              max: 100,
            },
            {
              name: params.firstScore[2].firstName,
              max: 100,
            },
            {
              name: params.firstScore[3].firstName,
              max: 100,
            },
            {
              name: params.firstScore[4].firstName,
              max: 100,
            },
            {
              name: params.firstScore[5].firstName,
              max: 100,
            },
          ],
          center: ["50%", "50%"], //位置
          radius: 45,
          startAngle: 90,
          splitNumber: 6,
          shape: "polygon",
          nameGap: 5,
          name: {
            formatter: "{value}",
            textStyle: {
              color: "rgba(239, 244, 255, 1)",
              fontSize: 12,
            },
          },
          splitArea: {
            areaStyle: {
              color: [
                "rgba(218, 230, 250, 1)",
                "rgba(218, 230, 250, 1)",
                "rgba(165, 178, 200, 0.6)",
                "rgba(78,83, 92, 0.75)",
                "rgba(70,77, 88, 0.4)",
                "rgba(116,125,141,0.3)",
              ],
              // shadowColor: 'rgba(70, 77, 88, 0.4)',
              // shadowBlur: 10
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
        },
      ],
      series: [
        {
          name: "雷达图",
          type: "radar",
          emphasis: {
            lineStyle: {
              width: 0,
            },
          },
          lineStyle: {
            width: 0,
          },
          data: [
            {
              value: params.totalScore,
              name: "车辆维度图",
              symbolSize: 4,
              areaStyle: {
                color: "rgba(161, 175, 202, 1)",
              },
              itemStyle: {
                color: "rgba(159, 178, 215, 1)",
              },
              labelLine: {
                show: false,
              },
            },
          ],
        },
      ],
    };
  }
  //获取价格数据
  getPriceData() {
    let params = {};
    getPrice(params).then((res: any) => {
      this.priceData = res.data;
      let data = {
        levelId: "",
        levelValue: "不限",
        minPrice: "",
        maxPrice: "",
      };
      this.priceData.unshift(data);
    });
  }
  //获取级别数据
  getLevelData() {
    let params = {};
    getLevel(params).then((res: any) => {
      let data = {
        levelId: "",
        levelValue: "不限",
        minPrice: "",
        maxPrice: "",
      };
      this.levelData = res.data;
      this.levelData.unshift(data);
    });
  }
  //获取品牌数据
  getBrandData() {
    let params = {};
    getBrand(params).then((res: any) => {
      this.brandData = res.data;
      for (let i in this.brandData) {
        this.indexList.push(this.brandData[i].letter);
      }
    });
  }
  clearcjOptArr(index: any, item: any) {
    this.cjOptArr.splice(index, 1);
    switch (item.name) {
      case "cjzx":
        this.cjParams.voteType = 0;
        break;
      case "cjpf":
        this.cjParams.sortType = 0;
        break;
      case "cjjg":
        this.cjParams.minPrice = "";
        this.cjParams.maxPrice = "";
        break;
      case "cjjb":
        this.cjParams.level = "";
        break;
      case "cjpp":
        this.cjParams.brandId = "";
        break;
      case "cjnk":
        this.cjParams.year = "";
        break;
    }
    this.initCjscoreData();
  }
  clearcjOptArrAll() {
    this.cjOptArr = [];
    this.changeDevelop(0);
  }
  //清除单项准备拆解选项
  clearZbcjOptArr(index: any, item: any) {
    this.zbcjOptArr.splice(index, 1);
    switch (item.name) {
      case "zbPrice":
        this.zbcjParams.maxPrice = "";
        this.zbcjParams.minPrice = "";
        this.zbcjPirceIndex = 0;
        break;
      case "zbzx":
        this.zbcjParams.sortType =1;
        this.zbcjPirceIndex = 0;
        break;
      case "zbjb":
        this.zbcjParams.level = "";
        this.zbCjlevelIndex = 0;
        break;
      case "zbpp":
        this.zbcjParams.brandId = "";
        break;
    }
    this.initZbCjscoreData();
  }
  clearZbcjOptArrAll() {
    this.zbcjOptArr = [];
    this.changeDevelop(2);
  }
}
